import React, { useState, useCallback, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'
import { useSetUrlParams, parseUrlParams } from '../hooks/useUrlParams'
import { useJsonQuery } from '../hooks/useQuery'
import { PannableArea } from '../components/PannableArea'

function CategoriesFilter(props) {
  const { queryUrl } = props
  const htmlContainer = useRef(document.querySelectorAll('[data-index-container]').item(0))

  const categoryGroups = props.categories || {}
  const categoryLabels = Object.keys(categoryGroups)

  const [panning, setPanning] = useState(false)
  const [selectionState, setSelectionState] = useState(parseUrlParams(['page']))

  console.log(selectionState)

  const toggleSelected = useCallback(
    (key, category) => {
      setSelectionState((selectionState) => {
        const newState = { ...selectionState }
        key = key.toLowerCase()
        if (!(key in newState)) newState[key] = []
        const selected = (newState[key] || []).indexOf(category.id) >= 0
        return {
          ...newState,
          [key]: selected ? newState[key].filter((id) => id !== category.id) : [...newState[key], category.id],
        }
      })
    },
    [categoryGroups]
  )

  const urlParams = { ...selectionState }

  const paramsStr = useSetUrlParams(urlParams, ['page'])

  const [{ pagination, html }, { loading, loaded }] = useJsonQuery(`${queryUrl}${paramsStr ? `?${paramsStr}` : ''}`, {
    pagination: {},
    html: null,
  })
  const initialFetchOccurred = useRef(false)

  useEffect(() => {
    if (html !== null) {
      if (!initialFetchOccurred.current) {
        console.log('ignoring initial fetch')
        initialFetchOccurred.current = true
        return
      }
      if (window.unmountDraggableAttributes) window.unmountDraggableAttributes()
      htmlContainer.current.innerHTML = html
      if (window.mountDraggableAttributes) window.mountDraggableAttributes()
      console.log(
        pagination.page < pagination.pageCount ? 'there are more pages to load' : 'all results contained on this page'
      )
    }
  }, [html])

  useEffect(() => {
    if (loaded || !loading) {
      htmlContainer.current.classList.remove('loading')
    } else if (loading) {
      htmlContainer.current.classList.add('loading')
    }
  }, [loading])

  return (
    <>
      <section className={cn('categories-filter-section container')}>
        <div className={cn('relative')}>
          <nav
            data-sticky
            className={cn(
              'hide-xs',
              'categories-filter',
              'categories-filter-desktop',
              'width-100',
              'padding-vertical-xs padding-horizontal-s',
              'flex flex-column align-items-flex-start gap-y-xxs',
              'background-white',
              'border-radius',
              'box-shadow-m'
            )}>
            {categoryLabels.map((label) => {
              const categories = categoryGroups[label] || []
              const selectedCategoryIds = selectionState[label.toLowerCase()] || []
              return (
                <div key={label} className={cn('flex align-items-center gap-xs width-1')}>
                  <label>{label}:</label>
                  <PannableArea
                    wrapperClass="flex-1-1-auto"
                    containerClass="inline-flex gap-xxxs overflow-visible"
                    onDragStart={() => setPanning(true)}
                    onDragEnd={() => setTimeout(() => setPanning(false), 50)}>
                    {categories.map((category) => {
                      const selected = selectedCategoryIds.indexOf(category.id) >= 0
                      return (
                        <div
                          key={category.id}
                          className={cn('attribute attribute-primary', { selected })}
                          onClick={() => !panning && toggleSelected(label, category)}>
                          {category.title}
                        </div>
                      )
                    })}
                  </PannableArea>
                </div>
              )
            })}
          </nav>
          {/* TODO: Mobile version */}
        </div>
      </section>
    </>
  )
}

window.CategoriesFilter = {
  init: (id, props) => {
    if (!props.categories) console.warn('No categories fam...')
    ReactDOM.render(<CategoriesFilter {...props} />, document.getElementById(id))
  },
}
